import { ModelView } from "../model.view";
import {
  CategoryModelVersion,
  CategoryStoreModel,
  DefaultCategoryStoreModel,
} from "@bitwarden/web-vault/app/models/store/category.store.model";
import { CategorySource } from "@bitwarden/web-vault/app/models/types/category.types";

export class CategoryView extends ModelView<CategoryStoreModel> {
  /** Readonly and private Field are located in the Base Class **/
  protected version: CategoryModelVersion;

  name: string;

  /** category is generated default */
  generatedDefault: boolean = false;

  source: CategorySource = "manual";

  constructor(model?: CategoryStoreModel) {
    super(model);

    if (typeof model === "object") {
      this.name = model.n;
      this.generatedDefault = model.gd;
      this.source = model.sc;
    } else {
      this.version = DefaultCategoryStoreModel.v;
    }
  }

  toStoreModel(): CategoryStoreModel {
    return {
      dc: this.dateCreated.toDateString(),
      dm: this.dateModified.toDateString(),
      id: this.id,
      vid: this.vaultId,
      v: this.version,
      n: this.name,
      gd: this.generatedDefault,
      sc: this.source,
    };
  }

  clone(): CategoryView {
    return new CategoryView(this.toStoreModel());
  }
}
